module.exports = __webpack_public_path__ + "static/media/ponudaPatosnice.91e2f38a.png";